import { createReducer, on } from '@ngrx/store';
import { retrievedIntegrations } from './integrations.actions';

export const i9nInitialState: ReadonlyArray<any> = [];

export const integrationsReducer = createReducer(
  i9nInitialState,
  on(retrievedIntegrations, (state, { integrations }) => [...integrations])
);
